var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSheetVoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Audio-ai"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M16.4997 3.65724C17.4201 3.65724 18.1667 4.40378 18.1667 5.32423V26.6758C18.1664 27.596 17.42 28.3418 16.4997 28.3418C15.5795 28.3417 14.8339 27.5959 14.8337 26.6758V5.32423C14.8337 4.40388 15.5794 3.65739 16.4997 3.65724ZM10.6667 8.76564C11.5871 8.76566 12.3337 9.5122 12.3337 10.4326V21.5693C12.3336 22.4897 11.5871 23.2363 10.6667 23.2363C9.74624 23.2363 8.99972 22.4898 8.99967 21.5693V10.4326C8.99967 9.51218 9.74622 8.76564 10.6667 8.76564ZM22.3288 8.76564C23.2491 8.76576 23.9948 9.51226 23.9948 10.4326V21.5693C23.9947 22.4897 23.2491 23.2362 22.3288 23.2363C21.4084 23.2363 20.6618 22.4898 20.6618 21.5693V10.4326C20.6618 9.51218 21.4083 8.76564 22.3288 8.76564ZM4.83366 12.1699C5.75379 12.1701 6.49944 12.9158 6.49967 13.836V19.0147C6.49967 19.935 5.75393 20.6815 4.83366 20.6817C3.91321 20.6817 3.16667 19.9351 3.16667 19.0147V13.836C3.1669 12.9157 3.91335 12.1699 4.83366 12.1699ZM28.1667 11.2529C29.0871 11.253 29.8337 11.9995 29.8337 12.9199V18.0986C29.8335 19.0189 29.087 19.7646 28.1667 19.7647C27.2463 19.7647 26.4999 19.0189 26.4997 18.0986V12.9199C26.4997 11.9995 27.2462 11.2529 28.1667 11.2529Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetVoice);
export default __webpack_public_path__ + "static/media/sheet-voice.7c8e3e50919d5515ec4daef8a50b50fe.svg";
export { ForwardRef as ReactComponent };